import curated_ipgln from '../assets/curated_ipgln.json'

export const getIpglnDescription = (ipglnCode: string, countryCode: string): string => {
    let ipglnDescription = curated_ipgln.find(c => c.ipglnCode === ipglnCode && c.countryCode === countryCode)?.ipglnDescription
    return ipglnDescription ? `${ipglnCode} - ${ipglnDescription}` : ipglnCode
}
